import { createSelector } from 'reselect';

const selectAgents = (state: any) => state.agents;

export const selectAgentsCurrentItem = createSelector([selectAgents], (agents) => agents.current);

export const selectAgentsListItems = createSelector([selectAgents], (agents) => agents.list);


export const selectAgentsItemById = (itemId: any) =>
    createSelector(selectAgentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAgentsQueryItems = createSelector([selectAgents], (agents) => agents.query);

export const selectAgentsCreatedItem = createSelector([selectAgents], (agents) => agents.create);

export const selectAgentsUpdatedItem = createSelector([selectAgents], (agents) => agents.update);

export const selectAgentsReadItem = createSelector([selectAgents], (agents) => agents.read);

export const selectAgentsDeletedItem = createSelector([selectAgents], (agents) => agents.delete);

export const selectAgentsSearchedItems = createSelector([selectAgents], (agents) => agents.search);

export const selectAgentsItemsCount = createSelector([selectAgents], (agents) => agents.count);

export const selectAgentsItemsFilter = createSelector([selectAgents], (agents) => agents.filter);